import { mantenimientoStats, mantenimientoIntroImage } from "@/mocks/serviceMantenimientoData";

export default function MantenimientoIntro() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="reveal order-2 lg:order-1">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
              El costo de no mantener
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              Lo que pagas por no hacer mantenimiento es mucho mayor que el mantenimiento mismo
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Un aire acondicionado sin mantenimiento pierde eficiencia, consume m&aacute;s energ&iacute;a y termina fallando en el peor momento. En{" "}
              <span className="text-[#0087a4] font-semibold">SERIN INGENIER&Iacute;A DE PROYECTOS SAS</span>{" "}
              aplicamos mantenimiento preventivo profesional para hogares, comercios, industrias y cuartos fr&iacute;os, evitando que un peque&ntilde;o descuido se convierta en una reparaci&oacute;n costosa.
            </p>
            <div className="grid grid-cols-2 gap-4">
              {mantenimientoStats.map((stat, i) => (
                <div
                  key={i}
                  className="reveal rounded-lg border border-background-200 bg-background-50 p-4"
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="text-2xl md:text-3xl font-bold text-[#0087a4] font-heading mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-600 leading-snug">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal relative h-[320px] md:h-[440px] rounded-lg overflow-hidden order-1 lg:order-2">
            <img
              src={mantenimientoIntroImage}
              alt="Técnico realizando mantenimiento preventivo"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-4 left-4 right-4 rounded-lg bg-background-50/95 backdrop-blur-sm p-4 border border-background-200">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#0087a4] flex items-center justify-center shrink-0">
                  <i className="ri-shield-check-line text-white text-lg" />
                </div>
                <p className="text-xs md:text-sm text-foreground-800 font-medium leading-snug">
                  T&eacute;cnicos certificados realizando un mantenimiento preventivo completo
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}